
import httpClient from "../Core/http";

class CustomerListAPi {
  getCustomerList(): Promise<any> {
    let url = "customers/customerList";
    return httpClient.get<any[]>(url).then((response) => {
     // console.log(response);
      return response.data;
    });
  }
  getPSTCustomerList(): Promise<any> {
    let url = "customers/pstCustomerList";
    return httpClient.get<any[]>(url).then((response) => {
      console.log(response);
      return response.data;
    });
  }
  getCadsList(): Promise<any> {
    let url = "customers/cads";
    return httpClient.get<any[]>(url).then((response) => {
      //console.log(response);
      return response.data;
    });
  }
  geSocomiaTest(): Promise<any> {
    let url = "socomea/test";
    return httpClient.get<any[]>(url).then((response) => {
     // console.log(response);
      return response.data;
    });
  }
  getHeaderGroups(): Promise<any> {
    let url = "machine/headerGroups";
    return httpClient.get<any[]>(url).then((response) => {
    //  console.log(response);
      return response.data;
    });
  }
  getHeaderValues(params: any): Promise<any> {
    let url = "machine/headerValues";
    return httpClient.get<any[]>(url, { params: params }).then((response) => {
     // console.log(response);
      return response.data;
    });
  }
  getHeaders(params: any): Promise<any> {
    let url = "machine/headers";
    return httpClient.get<any[]>(url, { params: params }).then((response) => {
     // console.log(response);
      return response.data;
    });
  }
}

export const CustomerListApi = new CustomerListAPi();
